module.exports = __webpack_public_path__ + "static/media/ark.e7719deb.svg";